import { Component, OnInit, Input, OnChanges, SimpleChanges, ElementRef, ViewChild, EventEmitter, Output, OnDestroy } from '@angular/core';
import { PaiementModel } from '../models/paiement.model';
import { TableMode, FormGeneratorService, BaseModel, StoreService } from '@ngx-resource-toolkit/core';
import { FormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

import * as _ from 'lodash';
import { CalculMontantService } from '../../services/calcul-montant.service';
import { ToasterService } from 'angular2-toaster';
import { SettingsService } from '../../../core/settings/settings.service';
import { ModalConfirmationComponent } from '../../miscellaneous/modal-confirmation.component';
import { DateHelper } from '../../helpers/date.helper';
import { ObjetLight } from '../../objetLight/models/ObjetLight';
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';
import { ExportService } from '../../services/export.service';
import { TabsService } from '../../services/tabs.service';
import { Router } from '@angular/router';
import { TABLE } from '../../../app.constantes';
import { FormatHelper } from '../../helpers/format.helper';
import { Subscription } from 'rxjs';
import { isOneOfSelectOptionsNull, SelectActions } from '../../resource/select.store';


const MaDatePipe = {transform: (value) => value ? DateHelper.timestampToDefault(value, true, false) : ''};
const PipeMontant = { transform: (value) => value ? FormatHelper.toChaineMonetaire(value) : '' };
@Component({
  selector: 'list-paiement',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListPaiementComponent implements OnInit, OnChanges, OnDestroy {

  public DateHelper = DateHelper;
  public TableMode = TableMode;
  // Pour la sélection dans l'auto-table
  private ColumnMode = ColumnMode;
  public SelectionType = SelectionType;
  @Input() public isSelectionOpen: boolean = true;

  @ViewChild('modal') modal: any;
  public modalMode: string;

  @ViewChild(ModalConfirmationComponent) modalConfirmation: any;
  public confirmationEvent: any;
  public confirmationMessage: string;
  public confirmationButtonType: string;
  public confirmationData: any;
  public confirmationButtonLabel: string;

  @ViewChild('dataTable', { read: ElementRef }) dataTable;

  @ViewChild('lienFamilleTpl') lienFamilleTpl: any;
  @ViewChild('listActionTemplate') listActionTemplate;

  @Input() public paiements: PaiementModel[];
  @Input() public buttons: string[];
  @Input() public tableButtons: string[];
  // If on show famille
  @Input() public familleId: string;
  @Input() public familleNom: string;

  @Input() public loading: boolean;
  @Input() public isButtonCopy: boolean = true;
  @Input() public isColumnFamilleVisible: boolean = true;
  @Output() save: EventEmitter<{ model: any, form: FormGroup }> = new EventEmitter<{ model: any, form: FormGroup }>();
  @Output() update: EventEmitter<{ model: any, form: FormGroup }> = new EventEmitter<{ model: any, form: FormGroup }>();
  @Output() delete: EventEmitter<{ model: any, params: any[] }> = new EventEmitter<{ model: any, params: any[] }>();
  @Output() retirePaiementDuBordereau: EventEmitter<{ model: any, params: any[] }> = new EventEmitter<{ model: any, params: any[] }>();
  @Output() totalPaiementsChanged: EventEmitter<number> = new EventEmitter<number>(); // en attendant de pouvoir l'ajouter
  // dans le footer, je le transmet
  @Output() actionFinished = new EventEmitter(); // Traitement terminé => demander à recharger les données si nécessaire

  @Input() public tableHeight = 'auto';

  public model: PaiementModel;
  public paiementModel: PaiementModel;
  public anneeScolaire: number; // pour les actions sur la sélection

  public totalPaiements: number;

  public forms: any;
  public paiementForm: FormGroup;

  public selected: Array<ObjetLight> = [];
  public selectedPaiements: Array<PaiementModel> = [];

  // Remplacement auto-table par le composant générique ngx-datatable
  public rows = [];
  columns = [];
  columnsAll = [ // Toutes ls colonnes : elles sont ensuite filtrées pour ne garder que les colonnes visibles dans this.columns
    { prop: 'id', name: 'N°', minWidth: TABLE.MIN_WIDTH.ID, cellTemplate: '', },
    { prop: 'bordereauNumero', name: 'N° Bordereau', minWidth: TABLE.MIN_WIDTH.ID, cellTemplate: '', }, // , pipe: pipe_type
    { prop: 'bordereauDate', name: 'Date bordereau', minWidth: TABLE.MIN_WIDTH.DATE, cellTemplate: '', pipe: MaDatePipe },
    { prop: 'familleNom', name: 'Famille', minWidth: TABLE.MIN_WIDTH.NOM_PRENOM, cellTemplate: this.lienFamilleTpl, },
    { prop: 'familleId', name: 'N° Fam', minWidth: TABLE.MIN_WIDTH.ID, cellTemplate: this.lienFamilleTpl, },
    { prop: 'tireur', name: 'Tireur', minWidth: TABLE.MIN_WIDTH.NOM_PRENOM, cellTemplate: '' },
    { prop: 'libelleTypePaiement', name: 'Mode paiement', minWidth: TABLE.MIN_WIDTH.LIBELLE_ACTION, cellTemplate: '' },
    { prop: 'numero', name: 'Numéro', minWidth: TABLE.MIN_WIDTH.ID, cellTemplate: '' },
    { prop: 'datePrevEncaiss', name: 'Date', minWidth: TABLE.MIN_WIDTH.DATE, cellTemplate: '', pipe: MaDatePipe, },
    { prop: 'montantPaiement', name: 'Montant', minWidth: TABLE.MIN_WIDTH.PAIEMENT_MONTANT, cellTemplate: '', pipe: PipeMontant, },
    { name: 'Actions', prop: 'actions', minWidth: 90, cellTemplate: '', }
  ];
  dataTabledefaultMessages = {
    emptyMessage: 'Aucune donnée disponible',
    selectedMessage: 'sélectionné(s)',
    totalMessage: 'ligne(s)',
  };

  private typesPaiements = [];
  private typePaiementSub: Subscription;

  constructor(
    private settings: SettingsService,
    private toaster: ToasterService,
    private http: HttpClient,
    private store: StoreService,
    private formGenerator: FormGeneratorService,
    private calculMontant: CalculMontantService,
    private exportService: ExportService,
    private tabsService: TabsService,
    private router: Router,
  ) {

  }

  onHide() {
    this.paiementModel = null;
    this.paiementForm = null;
  }

  ngOnDestroy() {
    if (this.typePaiementSub) {
      this.typePaiementSub.unsubscribe();
    }
  }

  initColumns() {
    this.columns = this.columnsAll.filter(col => {
      return (this.isColumnFamilleVisible || col.prop !== 'familleNom');
    });
    // console.log({toutes: this.columnsAll, filtrées: this.columns});
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.initColumns();
    if (this.paiements) {
      // Réinitialisation de la sélection
      this.selected = [];
      this.selectedPaiements = [];

      this.model = new PaiementModel({});

      this.forms = this.formGenerator.createFormGroup(this.paiements, 'table');

      this.calculMontant.updateValues({ paiements: this.paiements });
      this.calculMontant.getTotalPaiement().subscribe((data) => {
        // console.log('ListPaiementComponent', 'calculMontant.getTotalPaiement', data);
        this.totalPaiements = +data;
        this.totalPaiementsChanged.emit(this.totalPaiements);
      });

      if (this.familleId) {
        // console.log('on est sur une famille => masquer la colonne famille');
        this.model.registerEntryDynamicProperty(['table'], 'familleNom', 'hidden', true);
      }

      this.columns.forEach(column => {
        if (column.prop === 'actions') {
          column.cellTemplate = this.listActionTemplate;
        } else if (column.prop === 'familleNom' || column.prop === 'familleId') {
          column.cellTemplate = this.lienFamilleTpl;
        }
      });
      if (this.dataTable.nativeElement) {
        this.dataTable.nativeElement.style.height = this.tableHeight + 'px';
      }
    }
  }

  ngOnInit() {
    this.initColumns();
    this.anneeScolaire = this.settings.getUserSetting('anneeScolaire');

    this.typePaiementSub = this.store.getState(state => state.selectOptions)
        .do(selectOptions => {
            if (isOneOfSelectOptionsNull(selectOptions)) {
                this.store.dispatch(
                    SelectActions.fetch({
                        http: this.http,
                    })
                );
            }
        })
        .filter(selectOptions => !isOneOfSelectOptionsNull(selectOptions))
        .subscribe(data => {
            this.typesPaiements = data['typesPaiements'];
        });
  }

  openConsultPaiement(row) {
    console.log('openEditPaiement', row);
    this.modalMode = 'show';
    row.familleId = row.famille.id;
    row.anneeScolaire = this.settings.getUserSetting('anneeScolaire');
    this.paiementModel = new PaiementModel(row);
    this.paiementForm = this.formGenerator.createFormGroup(this.paiementModel, 'show');
    this.modal.open();
    console.log("l'objet paiments pour verif du format de la date", this.paiementForm );

  }

  openEditPaiement(rowIndex, row) {
    // TODO : recherger les données et vérifier que le paiement est éditable avant d'ouvrir la popup.
    // J'ai initialisé le component edit à cet effet
    // En attendant je mets un contrôle sur les données en mémoire pour limiter un peu
    if (row.bordereauNumero) {
      this.toaster.pop('error', 'Le paiement est déjà sur un bordereau.');
      this.openConsultPaiement(row);
      return;
    }
    this.modalMode = 'edit';
    row.familleId = row.famille.id;
    row.anneeScolaire = this.settings.getUserSetting('anneeScolaire');
    this.paiementModel = new PaiementModel(row);
    this.paiementModel.registerEntriesDynamicProperties(['create'], {
        'type': { options: this.typesPaiements },
    });
    this.paiementForm = this.formGenerator.createFormGroup(this.paiementModel, 'create');
    this.modal.open();
  }

  openCopyPaiement(rowIndex, row) {
    this.modalMode = 'create';
    row.familleId = row.famille.id;
    row.anneeScolaire = this.settings.getUserSetting('anneeScolaire');
    // row.datePrevEncaiss = new Date().getTime(); On garde la date du paiement copié
    this.paiementModel = new PaiementModel(row);
    this.paiementModel.registerEntriesDynamicProperties(['create'], {
        'type': { options: this.typesPaiements },
    });
    this.paiementForm = this.formGenerator.createFormGroup(this.paiementModel, 'create');
    this.modal.open();
  }

  printBordereau(rowIndex, row) {
    console.log('printBordereau', row);
    const numeroBordereau = row.bordereauNumero;
    if (!numeroBordereau) {
      this.toaster.pop('info', 'Le paiement n\'est pas sur un bordereau.');
      return;
    }
    const dateBordereau = row.bordereauDate;
    if (!dateBordereau) {
      this.toaster.pop('info', 'Le paiement n\'est pas sur un bordereau.');
      return;
    }
    // ServiceCompta ou ServicePaiement::getInstance()->generatePdfBordereauRemiseCheques($numero, $dateBordereau);
    // const paiementModel: BaseModel = new PaiementModel(event.row);
    const paiementModel = row;
    const params = [numeroBordereau, dateBordereau];
    // const service = 'facturation';
    const method = 'generatePdfBordereauRemiseCheques';
    const fileNameOnDisk = 'Bordereau_' + numeroBordereau;
    this.exportService.generePDF(paiementModel, params, method, fileNameOnDisk);
  }

  openConfirmationDelete(rowIndex, row) {
    this.confirmationEvent = null;
    this.confirmationMessage = `Voulez-vous vraiment supprimer le paiement n°${row.id} ?`;
    this.confirmationButtonType = 'deletePaiement';
    this.confirmationData = row;
    this.confirmationButtonLabel = 'Supprimer';
    // console.log('OpenConfirmationDelete', { confirmationMessage: this.confirmationMessage, confirmationEvent: this.confirmationEvent });
    this.modalConfirmation.modal.open();
  }

  openConfirmationRetraitBordereau(rowIndex, row) {
    this.confirmationEvent = null;
    this.confirmationMessage = `Voulez-vous vraiment retirer le paiement n°${row.id} du bordereau ${row.bordereauNumero} ?`;
    this.confirmationButtonType = 'retraitBordereau';
    this.confirmationData = row;
    this.confirmationButtonLabel = 'Retirer du bordereau';
    this.modalConfirmation.modal.open();
  }

  confirmationAction(event) {
    console.log('confirmationAction', event);
    switch (event.buttonType) {
      case 'retraitBordereau':
        console.log('Retrait du bordereau');
        this.retirePaiementDuBordereau.emit(event.data);
        break;
      case 'deletePaiement':
        console.log('Delete paiement');
        this.deletePaiement(event.data);
        break;
    }
  }

  openNewPaiement() {
    this.modalMode = 'create';

    this.paiementModel = new PaiementModel({
      familleId: this.familleId,
      anneeScolaire: this.settings.getUserSetting('anneeScolaire'),
      datePrevEncaiss: new Date().getTime(),
      isRemboursement: false, // par défaut il s'agit d'un paiement
      tireur: this.familleNom,
      type: '1', // Chèque (en chaine car sinon, non pris en compte)
    });

    this.paiementModel.registerEntriesDynamicProperties(['create'], {
        'type': { options: this.typesPaiements },
    });
    this.paiementForm = this.formGenerator.createFormGroup(this.paiementModel, 'create');

    this.modal.open();
  }

  savePaiement() {
    // éclatement de l'objet id/libellé
    const typePaiement = this.typesPaiements.filter(typPaiement => typPaiement.value == this.paiementForm.get('type').value);
    if (typePaiement.length > 0) {
        this.paiementForm.patchValue({libelleTypePaiement: typePaiement[0].label});
    }

    this.save.emit({
      form: this.paiementForm,
      model: this.paiementModel,
    });
  }

  editPaiement() {
    // éclatement de l'objet id/libellé
    const typePaiement = this.typesPaiements.filter(typPaiement => typPaiement.value == this.paiementForm.get('type').value);
    if (typePaiement.length > 0) {
        this.paiementForm.patchValue({libelleTypePaiement: typePaiement[0].label});
    }
    this.update.emit({
      form: this.paiementForm,
      model: this.paiementModel,
    });
  }

  deletePaiement(row) {
    console.log('deletePaiement', row);
    this.delete.emit({
      params: [row],
      model: new PaiementModel(row),
    });

  }

  isButtonInList(value: string) {
    return this.buttons instanceof Array ? this.buttons.includes(value) : false;
  }



  // Sélections dans l'auto-table liste paiements
  selectionChanged(famillesSelectionnees) {
    console.log('selectionChanged');
    // console.log('selectionChanged', famillesSelectionnees);
    this.selected = famillesSelectionnees;
    // Mise à jour de la sélection dans le tableau
    this.selectedPaiements = [];
    this.selected.forEach(element => {
      // element.id
      const elementSelectionne = this.paiements.find(function (cur: PaiementModel) {
        return +cur.id === element.id;
      });
      this.selectedPaiements.push(elementSelectionne);
    });
    // console.log('selected', this.selected, 'famillesSelectionnees', famillesSelectionnees);
  }

  /**
   * Sélectionne toutes les familles.
   */
  selectedAll() {
    console.log('selectedAll');
    this.selectedPaiements = this.paiements.filter(PaiementModel.isSelectionBordereauPossible);
    this.selected.splice(0, this.selected.length);
    this.selected = this.listPaiementToListObjetLight(this.selectedPaiements);
  }

  private listPaiementToListObjetLight(listPaiement: Array<PaiementModel>) {
    const listeLightObject: Array<ObjetLight> = [];
    listPaiement.forEach(element => {
      const objSel: ObjetLight = new ObjetLight({
        id: element.id,
        libelle: (element.famille ? element.famille.nom + ' ' : '') + element.montantPaiement,
        // TODO voir ce qu'il faut mettre dans le libellé
        typeObjet: 'R'
      });
      listeLightObject.push(objSel);
    });
    return listeLightObject;
  }

  onSelect(event) {
    if (this.isSelectionOpen) {
      const selected: Array<PaiementModel> = <PaiementModel[]>event['selected'];
      console.log('list paiements', 'Select Event', selected, this.selected);
      if (selected != null) {
        // Il faut d'abord filtrer les éléments sélectionnée : pas les espèces, pas les réglements qui sont déjà sur un bordereau
        this.selectedPaiements = selected.filter(PaiementModel.isSelectionBordereauPossible); // PaiementModel.isSelectionBordereauPossible
        this.selected.splice(0, this.selected.length);
        this.selected = this.listPaiementToListObjetLight(this.selectedPaiements);
      } else {
        this.selected = [];
      }
    }
  }

  // Indique que l'action sur la sélection est terminée et nécessite un rechargement des données : recharger les données
  finished() {
    console.log('finished');
    this.actionFinished.emit();
  }

  ouvreFamilleConsultation(nomFamille, idFamille) {
    console.log('ouvreFamilleConsultation', nomFamille, idFamille);
    // Laisser le nom en premier paramètre (même si non utilisé dans la fonction) car permet de garder le tri
    // de la colonne sur cette donnée.
    this.router.navigate(['/famille/show', idFamille]);

    this.tabsService.addTab({
      label: `${nomFamille} (${idFamille})`,
      link: '/famille/show/' + idFamille,
      group: 'famille',
      iconClass: 'fa fa-user'
    });
  }


  retraitBordereau(event) {
    console.log({ where: 'retraitBordereau'});
  }
}



// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/paiement/list/list.component.ts